import { GlobalState } from 'reducers';
import { getIsFeatureEnabledForUser } from 'selectors/features/getIsFeatureEnabledForUser';
import { Feature } from 'types/types';

export const getIsHomeHealthAlertEnabled = (state: GlobalState) =>
  getIsFeatureEnabledForUser(state, { feature: Feature.HomeHealthAlert });
